const install = (Vue, vm) => {
  let api = {};

  // 首页一级岗位菜单
  api.getJobOneList = (params = {}) =>
    vm.$u.post("/uni/job/job_first_list", params);
  // 首页一级岗位菜单
  api.saveJobOneList = (params = {}) =>
    vm.$u.post("/uni/user/config_job_menu", params);
  // 套餐暂停弹窗
  api.userOpenVIP = (params = {}) => vm.$u.post("/uni/user/open_vip", params);
  //全局配置
  api.cate = (params = {}) => vm.$u.post("/uni/common/cate", params);
  api.getSetting = (params = {}) => vm.$u.post("/uni/setting/info", params);
  //系统信息R
  api.system = (params = {}) => vm.$u.post("/uni/common/system", params);
  //根据域名获取地址
  api.hostCity = (params = {}) => vm.$u.post("/uni/common/host_city", params);
  api.shareConfig = (params = {}) =>
    vm.$u.post("/uni/share_config/index", params);
  //根据ip获取地址
  api.ipCity = (params = {}) => vm.$u.post("/uni/common/ip_city", params);
  //获取站点的网页配置
  api.webInfo = (params = {}) => vm.$u.post("/uni/site/web_info", params);
  //获取g功能配置
  api.funSetting = (params = {}) =>
    vm.$u.post("/uni/setting/getCommonConfigs", params);
  api.buzInfo = (params = {}) => vm.$u.post("/uni/site/buz_config", params);
  // 站点列表
  api.getSiteList = (params = {}) =>
    vm.$u.post("/uni/common/site_tree_list", params);
  //站点切换
  api.changeSite = (params = {}) =>
    vm.$u.post("/uni/common/change_site", params);
  //站点对应子地区列表
  api.getRegionChildList = (params = {}) =>
    vm.$u.post("/uni/region/child_list", params);
  // 发送短信
  api.sendSms = (params = {}) => vm.$u.post("/uni/common/send_sms", params);
  //支付
  api.orderPay = (params = {}) => vm.$u.post("/uni/order/order_pay", params);
  // 获取二维码
  api.getQcode = (params = {}) =>
    vm.$u.post("/uni/site/weixin_group_code", params);
  // 清楚 jwt
  api.clearToken = (params = {}) =>
    vm.$u.post("/uni/common/clearJwtTokenInBlackList", params);
  // 获取通用设置
  api.getUserConfig = (params = {}) =>
    vm.$u.post("/uni/site/get_user_config", params);

  // 注册
  api.register = (params = {}) => vm.$u.post("/uni/register/index", params);
  // 登陆
  api.login = (params = {}) => vm.$u.post("/uni/login/login", params);
  //图片验证码
  api.imgCode = (params = {}) => vm.$u.post("/uni/common/img_code", params);
  // 短信登陆
  api.smsLogin = (params = {}) => vm.$u.post("/uni/login/sms_login", params);
  //小程序登陆
  api.miniLogin = (params = {}) => vm.$u.post("/uni/login/mini_login", params);
  //小程序获取手机号
  api.miniPhone = (params = {}) => vm.$u.post("/uni/login/mini_phone", params);
  //code换key--第三方
  api.weixinLogin = (params = {}) =>
    vm.$u.post("/uni/login/weixin_login", params);
  //检查微信环境
  api.wxconfig = (params = {}) =>
    vm.$u.post("/uni/site/weixin_jssdk_config", params);
  //检查token是否过期
  api.checkToken = (params = {}) =>
    vm.$u.post("/uni/common/token_validate", params);
  //修改手机号
  api.changePhone = (params = {}) =>
    vm.$u.post("/uni/login/change_phone", params);
  //修改密码
  api.changePassword = (params = {}) =>
    vm.$u.post("/uni/login/change_password", params);
  // 绑定小程序
  api.bindMini = (params = {}) =>
    vm.$u.post("/uni/user/bind_mini_authorize", params);
  // 绑定公众号
  api.bindGzh = (params = {}) =>
    vm.$u.post("/uni/user/bind_wehcat_authorize", params);

  // 点击广告增加阅读次数
  api.addBannerNum = (params = {}) => vm.$u.post("/uni/index/view_ad", params);
  // 轮播图列表
  api.getBannerList = (params = {}) => vm.$u.post("/uni/index/ad_list", params);
  // 推荐企业列表
  api.getIndexCompanyList = (params = {}) =>
    vm.$u.post("/uni/company/list", params);
  // 企业广告位
  api.getAdCompanyList = (params = {}) =>
    vm.$u.post("/uni/index/ad_list", params);

  // 招聘数据
  api.getRecruitList = (params = {}) =>
    vm.$u.post("/uni/recruit/page_list", params);
  //优先企业的招聘数据
  api.getTopMemberRecruitList = (params = {}) =>
    vm.$u.post("/uni/recruit/top_member_page_list", params);
  // 招聘详情
  api.getRecruitDetail = (params = {}) =>
    vm.$u.post("/uni/recruit/detail", params);
  //招聘详情分享二维码
  api.getWechatCode = (params = {}) =>
    vm.$u.post("/index/api/detail_qcode", params);
  // 获取招聘号码
  api.getRecruitPhone = (params = {}) =>
    vm.$u.post("/uni/resume_user/recruit_phone", params);
  //申请职位前检查
  api.beforeApplyRecruit = (params = {}) =>
    vm.$u.post("/uni/resume_user/befor_apply_recruit", params);
  //申请职位
  api.applyRecruit = (params = {}) =>
    vm.$u.post("/uni/resume_user/apply_recruit", params);
  //获取电话
  api.phoneRecruit = (params = {}) => vm.$u.post("/uni/recruit/phone", params);
  //拨打电话
  api.callPhoneRecruit = (params = {}) =>
    vm.$u.post("/uni/recruit/call_phone", params);

  //公招列表
  api.getGongzhaoList = (params = {}) =>
    vm.$u.post("/uni/article/page_list", params);
  //公招详情
  api.getGongzhaoDetail = (params = {}) =>
    vm.$u.post("/uni/article/detail", params);
  api.getArticleCategoryList = (params = {}) =>
    vm.$u.post("/uni/article/getChildrenCategory", params);

  //企业模块
  //获取企业分页列表
  api.getCompanyList = (params = {}) =>
    vm.$u.post("/uni/company/page_list", params);
  //企业详情
  api.getCompanyDetail = (params = {}) =>
    vm.$u.post("/uni/company/detail", params);
  // 企业地址修改
  api.editCompanyAdress = (params = {}) =>
    vm.$u.post("/uni/recruit_user/edit_company_address", params);

  //简历模块

  // 投递岗位
  api.postedRecruitList = (params = {}) =>
    vm.$u.post("/uni/recruit_user/postedRecruitList", params);
  // 备注
  api.resumeRemark = (params = {}) =>
    vm.$u.post("/uni/recruit_user/remarkResume", params);
  //获取简历分页列表
  api.getResumeList = (params = {}) =>
    vm.$u.post("/uni/resume/page_list", params);
  //简历详情
  api.getResumeyDetail = (params = {}) =>
    vm.$u.post("/uni/resume/detail", params);
  //求职岗位分类
  api.getResumeType = (params = {}) =>
    vm.$u.post("/uni/job/job_tree_list", params);
  //求职状态
  api.getResumeStatus = (params = {}) => vm.$u.post("/uni/common/cate", params);
  // 更新简历已读状态
  api.markReadedResume = (params = {}) =>
    vm.$u.post("/uni/recruit_user/mark_readed_resume", params);

  //-----------------//
  // 我的
  //----------------//
  api.changeUsername = (params = {}) =>
    vm.$u.post("/uni/login/change_username", params);
  api.checkAccountExist = (params = {}) =>
    vm.$u.post("/uni/login/check_account_exist", params);
  //我的信息
  api.userInfo = (params = {}) => vm.$u.post("/uni/user/info", params);
  //用户信息修改
  api.editUserInfo = (params = {}) => vm.$u.post("/uni/user/edit_info", params);
  //反馈
  api.feedback = (params = {}) => vm.$u.post("/uni/user/report", params);
  //--------------- 求职者
  //我的简历
  api.myResume = (params = {}) =>
    vm.$u.post("/uni/resume_user/my_resume", params);
  //刷新简历
  api.updateResume = (params = {}) =>
    vm.$u.post("/uni/resume_user/update_resume", params);
  //我的投递
  api.myApplyRecruit = (params = {}) =>
    vm.$u.post("/uni/resume_user/my_apply_recruit", params);
  //收藏职位
  api.collectResume = (params = {}) =>
    vm.$u.post("/uni/resume_user/collect", params);
  //我的收藏
  api.myCollect = (params = {}) =>
    vm.$u.post("/uni/resume_user/collect_recruits", params);
  //修改简历
  api.editResume = (params = {}) =>
    vm.$u.post("/uni/resume_user/edit_resume", params);
  // 快捷注册
  api.newEditResume = (params = {}) =>
    vm.$u.post("/uni/resume_user/pure_update_resume", params);
  //修改、添加工作经验
  api.editWork = (params = {}) =>
    vm.$u.post("/uni/resume_user/edit_work", params);
  //删除工作经验
  api.delWork = (params = {}) =>
    vm.$u.post("/uni/resume_user/delete_work", params);
  //修改、添加教育经历
  api.editEducation = (params = {}) =>
    vm.$u.post("/uni/resume_user/edit_education", params);
  //删除教育经历
  api.delEducation = (params = {}) =>
    vm.$u.post("/uni/resume_user/delete_education", params);
  //我的订阅
  api.findJobs = (params = {}) =>
    vm.$u.post("/uni/resume_user/find_jobs", params);
  //编辑订阅职位
  api.setSubscribe = (params = {}) =>
    vm.$u.post("/uni/resume_user/edit_find_jobs", params);
  //订阅岗位的招聘
  api.findJobsRecruit = (params = {}) =>
    vm.$u.post("/uni/resume_user/find_jobs_recruit", params);
  // 检查是否投递简历
  api.checkHasApply = (params = {}) =>
    vm.$u.post("/uni/resume_user/has_apply", params);

  //--------------- 招聘者
  // 订单确认
  api.orderPayV2 = (params = {}) =>
    vm.$u.post("/uni/v2.order/order_pay", params);
  // 获取企业专属客服
  api.getCustomerService = (params = {}) =>
    vm.$u.post("/uni/user/qy_exclusive_customer_service", params);
  // 获取交易配置
  api.getTransactionConfig = (params = {}) =>
    vm.$u.post("/uni/site/transaction_config", params);
  // 金豆充值列表
  api.getGoldBeanList = (params = {}) =>
    vm.$u.post("/uni/virtual_currency/goldBeanList", params);
  // 购买金豆
  api.buyGoldBean = (params = {}) =>
    vm.$u.post("/uni/virtual_currency/buyGoldBeans", params);
  //套餐列表
  // api.packageList = (params = {}) => vm.$u.post('/uni/package/list', params)
  api.packageList = (params = {}) => vm.$u.post("/uni/v2.package/list", params);
  // 套餐余额
  api.getMembershipInfo = (params = {}) =>
    vm.$u.post("/uni/user/getUserMembershipBalanceInfo", params);
  //套餐下单
  api.packagePay = (params = {}) => vm.$u.post("/uni/package/buy", params);
  // 套餐下单v2
  api.packagePayV2 = (params = {}) => vm.$u.post("/uni/v2.package/buy", params);

  //我的招聘
  api.myResruitList = (params = {}) =>
    vm.$u.post("/uni/recruit_user/recruit_list", params);
  //置顶招聘
  // api.myResruitTop = (params = {}) => vm.$u.post('/uni/recruit_user/top', params)
  api.changeAutoTop = (params = {}) =>
    vm.$u.post("/uni/recruit_user/update_auto_top", params);
  //置顶条件列表
  api.myTopList = (params = {}) =>
    vm.$u.post("/uni/common_user/top_list", params);
  //刷新招聘
  api.myResruitRefresh = (params = {}) =>
    vm.$u.post("/uni/recruit_user/refresh", params);
  //自动刷新招聘信息
  api.autoRefreshResruit = (params = {}) =>
    vm.$u.post("/uni/recruit_user/update_auto_refresh", params);
  //下载或投递的简历
  api.myDownApplyResume = (params = {}) =>
    vm.$u.post("/uni/recruit_user/resume_list", params);
  //删除下载或投递的简历
  api.delDownApplyResume = (params = {}) =>
    vm.$u.post("/uni/recruit_user/delete_resume", params);
  //下载检查
  api.checkResume = (params = {}) =>
    vm.$u.post("/uni/recruit_user/check_resume", params);
  //下载简历
  api.downResume = (params = {}) =>
    vm.$u.post("/uni/recruit_user/down_resume", params);
  //我的招聘详情
  api.myResruitDetail = (params = {}) =>
    vm.$u.post("/uni/recruit_user/recruit_detail", params);
  //检查企业是否认证
  api.checkCoAuth = (params = {}) =>
    vm.$u.post("/uni/recruit_user/check_qy_auth", params);
  //编辑招聘
  api.myResruitPublishUpdate = (params = {}) =>
    vm.$u.post("/uni/recruit_user/update", params);
  //删除招聘
  api.myResruitDelete = (params = {}) =>
    vm.$u.post("/uni/recruit_user/delete", params);
  //编辑招聘显示状态
  api.myResruitShowUpdate = (params = {}) =>
    vm.$u.post("/uni/recruit_user/update_show", params);
  //发布招聘
  api.myResruitPublish = (params = {}) =>
    vm.$u.post("/uni/recruit_user/publish", params);
  // 发布岗位前查用户余额
  api.checkPublish = (params = {}) =>
    vm.$u.post("/uni/recruit_user/check_publish", params);
  // 检查发布、加急、刷新、下载
  api.checkResumeOperation = (params = {}) =>
    vm.$u.post("/uni/recruit_user/check_operation", params);
  //我的订单
  api.myOrderList = (params = {}) => vm.$u.post("/uni/order/page_list", params);
  //我的流水
  api.mySurplusList = (params = {}) =>
    vm.$u.post("/uni/surplus/page_list", params);
  //企业认证提交
  api.editCompany = (params = {}) =>
    vm.$u.post("/uni/recruit_user/edit_company", params);
  //企业地址列表
  api.getCompanyAddressList = (params = {}) =>
    vm.$u.post("/uni/recruit_address/index", params);
  //地址详情
  api.getCompanyAddressDetail = (params = {}) =>
    vm.$u.post("/uni/recruit_address/detail", params);
  // 企业地址添加
  api.addCompanyAddress = (params = {}) =>
    vm.$u.post("/uni/recruit_address/add", params);
  // 地址逆解析
  api.mapRego = (params = {}) => vm.$u.post("/uni/common/map_regeo", params);
  // 企业地址修改
  api.editCompanyAddress = (params = {}) =>
    vm.$u.post("/uni/recruit_address/edit", params);
  // 企业地址删除
  api.removeCompanyAddress = (params = {}) =>
    vm.$u.post("/uni/recruit_address/drop", params);
  //企业营业执照提交
  api.editCompanyCert = (params = {}) =>
    vm.$u.post("/uni/recruit_user/edit_company_cert", params);

  /** 账号设置 */
  // 账号解绑
  api.acountUnbind = (params = {}) =>
    vm.$u.post("/uni/user/unbind_wechat", params);
  // 账号绑定
  api.accountBind = (params = {}) => vm.$u.post("", params);

  //聊天
  api.editChatPhrases = (params = {}) =>
    vm.$u.post("/uni/chat_phrases/edit", params);
  api.addChatPhrases = (params = {}) =>
    vm.$u.post("/uni/chat_phrases/create", params);
  api.chatPhrasesList = (params = {}) =>
    vm.$u.post("/uni/chat_phrases/list", params);
  api.beforChatCheck = (params = {}) =>
    vm.$u.post("/uni/chat/check_can_chat", params);
  api.chatQyChat = (params = {}) =>
    vm.$u.post("/uni/chat/check_qy_chat", params);
  api.chatUseFul = (params = {}) => vm.$u.post("/uni/chat/useful", params);
  api.chatUserInfo = (params = {}) =>
    vm.$u.post("/uni/chat/chat_user_info", params);
  api.chatUserList = (params = {}) =>
    vm.$u.post("/uni/chat/recent_contacts", params);
  api.chatLogList = (params = {}) => vm.$u.post("/uni/chat/chat_log", params);
  api.chatNoReadNum = (params = {}) =>
    vm.$u.post("/uni/chat/no_read_num", params);

  api.recruitTimeNotice = (params = {}) =>
    vm.$u.post("/uni/recruit_user/real_time_notice", params);
  api.chatInfo = (params = {}) => vm.$u.post("/uni/chat/chat_info", params);
  api.chatPhraseDel = (params = {}) =>
    vm.$u.post("/uni/chat_phrases/delete", params);

  // 求职助手
  api.getQuestions = (params = {}) =>
    vm.$u.post("/uni/job_assistant/question_list", params);
  api.updatePerResume = (params = {}) =>
    vm.$u.post("/uni/resume_user/pure_update_resume", params);
  api.getSmartRobotConfig = (params = {}) =>
    vm.$u.post("/uni/job_assistant/get_config", params);
  api.getSiteRegionTreeList = (params = {}) =>
    vm.$u.post("/uni/site_region/tree_list", params);

  // 教师系列
  api.getTeacherTitleList = (params = {}) =>
    vm.$u.post("/uni/common/teacher_title", params);

  api.getHonersList = (params = {}) =>
    vm.$u.post("/uni/common/get_honors", params);
  api.saveHonersCertificate = (params = {}) =>
    vm.$u.post("/uni/resume_user/edit_honor_certificate", params);
  api.delHonersCertificate = (params = {}) =>
    vm.$u.post("/uni/resume_user/delete_honor_certificate", params);
  api.delTraining = (params = {}) =>
    vm.$u.post("/uni/resume_user/delete_training", params);
  api.saveTraining = (params = {}) =>
    vm.$u.post("/uni/resume_user/edit_training", params);
  api.updateShow = (params = {}) =>
    vm.$u.post("/uni/resume_user/update_show", params);
  api.searchSchool = (params = {}) =>
    vm.$u.post("/uni/common/search_school", params);

  api.getResumeAttachment = (params = {}) =>
    vm.$u.post("/uni/resume_user/showReviewFailAlert", params);
  api.attachmentFileList = (params = {}) =>
    vm.$u.post("/uni/resume_attachment/index", params);
  api.delAttachmentFile = (params = {}) =>
    vm.$u.post("/uni/resume_attachment/delete", params);
  api.getBlacklist = (params = {}) =>
    vm.$u.post("/uni/user_blacklist/index", params);
  api.blacklistSearch = (params = {}) =>
    vm.$u.post("/uni/user_blacklist/searchUser", params);
  api.createBlacklist = (params = {}) =>
    vm.$u.post("/uni/user_blacklist/create", params);
  api.delBlacklist = (params = {}) =>
    vm.$u.post("/uni/user_blacklist/delete", params);

  vm.$u.api = api;
};

export default {
  install,
};
